const promotions = {
    isBusy: false,
    default: {
        isActive: false,
    },
    trials: [],
    discount: [],
    refetch: false
};

export default promotions;
